import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Button } from 'advenio-components'
import { path } from 'ramda'
import {
  PillsRow,
  Pills,
} from './ProfilePanel.styles'


const StatusBarColor = {
  Inactive: '#E2E8EC',
  "Nurse's Room": '#D0021B',
  Home: '#4A4A4A',
}

const StatusText = {
  Inactive: 'Este alumno se encuentra ausente',
  "Nurse's Room": 'En Sintomas',
  Home: 'Regresó a casa',
}

const StatusIconPath = {
  Inactive: '',
  "Nurse's Room": '/assets/symptom_icon.svg',
  Home: '/assets/home_icon.svg',
}

const PannelContainer = styled.div`
  background-color: white;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 0 8px 0;
  flex-direction: column;
`
const InfoContainer = styled.div`
  padding-left: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  margin-bottom: 8px;
`

const ActionsContainer = styled.div`
display: ${props => props.status === 'Advenio' ? 'flex' : 'none'};
  justify-content: flex-start;
  padding: 8px 0 8px 0px;
  height: 50px;
  width: 100%;
`
const ProfilePicture = styled.div`
  background-image: ${props => props.profile ? 'url(' + props.profile + ')' : 'url(/assets/BabyAvatar.svg)'};
  background-size: cover;
  background-position: center;
  width: 70px;
  height: 70px;
  border-radius: 4px;
  background-color: white;
  padding-left: 8px;
  @media (max-width: 763px) {
    width: 70px;
    height: 70px;
  }
`
const ProfileInfoContainer = styled.div`
  padding-left: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`
const ProfileName = styled.h2`
  font-weight: 400;
  margin: 0;
`

const NewButton = styled(Button)`
  padding: 0 4px 0 4px;
  margin-right: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span {
    font-size: 12px;
    margin-left: 0;
    margin-right: 4px;
  }
  svg{
    width: 16px;
    height: 16px;
  }
`

const StatusBar = styled.div`
  display: ${props => props.status === 'checkIn' ? 'none' : 'flex'};
  background-color: ${props => StatusBarColor[props.status]};
  color:${props => props.status === 'checkOut' ? '#4A4A4A' : 'white'};
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px 0 8px 0;
  font-size: 12px;
`

const StatusIcon = styled.img`
  margin: 0 4px 0 4px;
`
const CloudIcon = styled.img`
  width: 13px;
  margin: 0 4px 0 4px;
`
const DegreeLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: rgba(74,74,74,.7)
`

const DegreeColor = styled.div`
  width:12px;
  height: 12px;
  border-radius: 6px;
  background-color: #75B753;
  margin-right: 4px;
  position: relative;

  &::after {
    content:"";
    border: 1.5px solid white;
    border-bottom:0;
    border-left: 0;
    width: 4px;
    height: 2px;
    position: absolute;
    top:3.5px;
    left: 3.5px;
    transform: rotate(135deg);
  }
`

const Icon = styled.img`
  width: 15px;
  margin: 4px;
`

class ProfilePanelMobile extends Component {
  onNewActivityClick = () => {
    this.props.onNewActivityClick()
  }

  onCheckOutClick = () => {
    this.props.onCheckOut()
  }

  onActionsClick = () => {
    this.props.onMoreActionsClick()
  }

  render() {
    const { student } = this.props
    return (
      <PannelContainer>
        <InfoContainer>
          <ProfilePicture profile={student.profile_pictures && student.profile_pictures['original']} />
          <ProfileInfoContainer>
            <ProfileName>
              {`${student.first_name ? student.first_name : ''}
              ${student.last_name_paternal ? student.last_name_paternal : ''}
              ${student.last_name_maternal ? student.last_name_maternal : ''}`}
            </ProfileName>
            {student.latest_health_check &&
              <DegreeLabel><DegreeColor /> {student.latest_health_check.temperature}˚</DegreeLabel>}
            <PillsRow>
              {this.props.infoPills.classroom ?
                <Pills>
                  {this.props.infoPills.classroom}
                </Pills> : null
              }
              {this.props.infoPills.studyProgram ?
                <Pills>
                  {this.props.infoPills.studyProgram}
                </Pills> : null
              }
              {path(['checkin', 'is_virtual_center'], student) && <Pills>
                <CloudIcon src="/assets/cloud_blue.svg" />{student.center && student.center.name}</Pills> }
            </PillsRow>
          </ProfileInfoContainer>
        </InfoContainer>
        <ActionsContainer status={path(['checkin', 'status'], student) ? student.checkin.status : 'Inactive'}>
          <NewButton
            primary
            small
            onClick={this.onNewActivityClick}
          >
            <Icon src="/assets/add_activity_white.svg" />
            <span>Agregar Actividad</span>
          </NewButton>
          <NewButton
            ghost
            small
            onClick={this.onCheckOutClick}
          >
            <Icon src="/assets/check_out.svg" />
            <span>Check out</span>
          </NewButton>
          <Button
            onClick={this.onActionsClick}
          >
            <img src="/assets/more_actions_vertical.svg" alt="more actions" />
          </Button>
        </ActionsContainer>
        <StatusBar status={path(['checkin', 'status'], student) ? student.checkin.status : 'Inactive'}>
          <StatusIcon src={path(['checkin', 'status'], student) ? StatusIconPath[student.checkin.status] : StatusIconPath.Inactive} />
          <i>{path(['checkin', 'status'], student) ? StatusText[student.checkin.status] : StatusIconPath.Inactive}</i>
        </StatusBar>
      </PannelContainer>
    )
  }
}

ProfilePanelMobile.propTypes = {
  student: PropTypes.object.isRequired,
  classrooms: PropTypes.array,
  infoPills: PropTypes.object,
}

ProfilePanelMobile.defaultProps = {
  classrooms: [],
  infoPills: {},
}

export default ProfilePanelMobile



// WEBPACK FOOTER //
// ./src/Components/ProfilePanel/ProfilePanelMobile.jsx